import { StyleSheet, TextStyle } from "react-native";

interface TextStyles {
  baseText: TextStyle;
}

export const styles = StyleSheet.create<TextStyles>({
  baseText: {
    fontFamily: "HelveticaNeue",
    fontSize: 12,
  },
});
